import { AlertColor } from "@mui/material";
import * as alertTypes from "../types/alert.types";
export type alertStateType = {
  type: AlertColor | undefined;
  message: string;
  messages: string[];
};
const initialState: alertStateType = {
  type: undefined,
  message: "",
  messages: [],
};

export default function alertReducer(state = initialState, action: any) {
  switch (action.type) {
    case alertTypes.SUCCESS:
      return {
        type: "success",
        message: action.message,
      };
    case alertTypes.MULTIPLE:
      return {
        type: "multiple",
        messages: action.messages,
      };
    case alertTypes.ERROR:
      return {
        type: "error",
        message: action.message,
      };
    case alertTypes.CLEAR:
      let messages = state?.messages ?? [];
      messages?.pop();
      return { ...state, messages, message: "" };
    default:
      return state;
  }
}
